export const APIHOST = import.meta.env.VITE_APIHOST;